import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { useEffect, useState } from "react";

const MESSAGES = [
  "Aligning the constellations…",
  "Listening to the planetary chorus…",
  "Tracing your natal blueprint…",
  "Reading what the stars have kept for you…",
  "Translating cosmic signal into language…",
];

export const LoadingState = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 2400);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      data-testid="loading-state"
      className="relative min-h-screen flex flex-col items-center justify-center px-6 py-20"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col items-center text-center"
      >
        <div className="relative">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 18, repeat: Infinity, ease: "linear" }}
            className="w-40 h-40 rounded-full border border-stardust/20"
            style={{
              background: "radial-gradient(circle at 30% 30%, rgba(212,175,55,0.15), transparent 60%)",
            }}
          />
          <motion.div
            animate={{ rotate: -360 }}
            transition={{ duration: 26, repeat: Infinity, ease: "linear" }}
            className="absolute inset-4 rounded-full border border-stardust/10"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <motion.div
              animate={{ scale: [1, 1.15, 1], opacity: [0.7, 1, 0.7] }}
              transition={{ duration: 3, repeat: Infinity }}
            >
              <Sparkles className="h-10 w-10 text-stardust" />
            </motion.div>
          </div>
        </div>

        <p className="text-stardust/80 uppercase tracking-[0.3em] text-[10px] mt-12 mb-3">Consulting the cosmos</p>

        <motion.h2
          key={idx}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="heading-serif font-serif-italic text-2xl sm:text-3xl text-white max-w-md"
          data-testid="loading-message"
        >
          {MESSAGES[idx]}
        </motion.h2>
      </motion.div>
    </section>
  );
};
